let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4OFbX")).then(() => parcelRequire('7UO5c'));